module.exports = __webpack_public_path__ + "static/media/Fantasy_4_t.5e3f8da2.jpg";